export default {
  title: 'Impuestos y moneda',
  subtitle: 'Administra las categorías fiscales usadas para fijar el precio de los artículos del menú.',
};
